/*
 * @Author: Shirtiny
 * @Date: 2021-06-08 17:06:56
 * @LastEditTime: 2021-08-19 09:50:59
 * @Description:
 */
import _ from "lodash";
import qs from "qs";


// 合并数组  以[path]为主键
export function unionBy(path, ...array) {
  return _.unionBy(...array, path);
}

// 解析url search param
function qsParse(str = "", option) {
  let searchStr = str;
  // 判断字符串第一个字符是不是问号
  if (searchStr.slice(0, 1) === "?") {
    searchStr = searchStr.slice(1);
  }
  return qs.parse(searchStr, option);
}

// 将文件读取为字符串
function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reader.abort();
      reject(new Error("读取文件失败!\n\n" + reader.error));
    };
    reader.readAsText(file);
  });
}

const util = { unionBy, qsParse, readFileAsText };

export default util;
